"use client"

import Image from "next/image"
import { motion } from "framer-motion"

export function HeroSection() {
  return (
    <section
      id="about"
      className="relative bg-background py-8 sm:py-12 lg:py-0 lg:min-h-screen lg:flex lg:items-center "
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-stretch gap-6 lg:gap-8">
          {/* Text Content - Above photo on mobile, right side on desktop */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full lg:w-1/2 order-1 lg:order-2"
          >
            <div className="w-full h-full bg-muted/50 rounded-2xl sm:rounded-3xl lg:rounded-[2.5rem] shadow-xl px-6 sm:px-8 lg:px-12 py-8 sm:py-10 lg:py-14 flex flex-col justify-center">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-semibold leading-tight text-foreground mb-4 sm:mb-6">
                Hi, I'm Fabio,
                <br />
                your personal Concierge.
              </h2>

              <p className="text-sm sm:text-base lg:text-lg text-foreground/70 leading-relaxed font-sans mb-6 sm:mb-8">
                After living in New York for 15 years, I founded Your Taormina Concierge to offer a more human, direct and
                premium experience. I'll assist you in choosing the perfect hotel, plan unforgettable excursions,
                transfers, boat tours, restaurant bookings and even weddings.
              </p>

              <a
                href="#services"
                className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-600 font-medium text-base sm:text-lg font-sans transition-colors"
              >
                Discover our services
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="mt-0.5">
                  <path
                    d="M4 10h12M12 6l4 4-4 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </motion.div>

          {/* Image - Below text on mobile, left side on desktop */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-full lg:w-1/2 order-2 lg:order-1"
          >
            <div className="relative w-full h-full min-h-[300px] sm:min-h-[400px] rounded-2xl sm:rounded-3xl lg:rounded-[2.5rem] overflow-hidden shadow-2xl">
              <Image
                src="/images/file_859.jpg"
                alt="Fabio - Your Personal Concierge in Taormina"
                fill
                className="object-cover object-center"
                sizes="(max-width: 1024px) 100vw, 50vw"
                priority
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
